module.exports = __webpack_public_path__ + "media/img/bg-1-5387bd68.png";